import Vue from 'vue';

export const RACE_REGION_ENUMS = /** @type {const} */({
  UK: 'uk',
  MX: 'mx',
  AU: 'au',
});

export const RACE_REGION_FILE_EXTENSION = /** @type {const} */({
  [RACE_REGION_ENUMS.UK]: 'svg',
  [RACE_REGION_ENUMS.AU]: 'svg',
  [RACE_REGION_ENUMS.MX]: 'png',
});

// FIXME: this needs not to be fixed, we can't keep hardcoded market ids on FE
export const RACE_MARKET_ID = /** @type {const} */({
  FORECAST: 1752,
  FORECAST_ANY: 1753,
  TRICAST: 1754,
  TRICAST_ANY: 1755
});

// FIXME: this needs to be translated,
export const RACE_MARKET_ID_NAME = /** @type {const} */({
  [RACE_MARKET_ID.FORECAST]: 'Public.M.Forecast',
  [RACE_MARKET_ID.FORECAST_ANY]: 'Public.M.ForecastAny',
  [RACE_MARKET_ID.TRICAST]: 'Public.M.Tricast',
  [RACE_MARKET_ID.TRICAST_ANY]: 'Public.M.TricastAny',
});


export const RACE_RUNNERS_POSITIONS = /** @type {const} */({
  FIRST: '1',
  SECOND: '2',
  THIRD: '3',
  ANY: 'Any'
});

export const RACING_BETTING_TYPES = /** @type {const} */({
  WINNER_EW: 1,
	FORECAST: 2,
	TRICAST: 3,
});

export const RACE_CAST_ITEM_TYPE = /** @type {const} */({
  REGULAR: 1,
	ANY: 2,
}); 